export const column = {
    render: 'Column',
    children: ['paragraph', 'tag', 'list', 'fence'],
};
